import { fun_PostAction } from "@/api";
import OrganizationAllocationDetails from "./details/index.vue";
import RecordDirectlyLogsDetails from "@/views/page/record/contractRecordDirectly/recordDirectlyLogs/details";
import {fun_GetKeys} from "@/utils/validate";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 直接发包主键
      contractRecordDirectlyId: null,
      // 项目名称
      prjName: null,
      // 操作标志
      controllerFlg: null,
      // 表头按钮组
      btnList: [

      ],
      // 查询表单绑定值
      form: {
        name: null, // 姓名
      },
      // 查询表单基础数据
      formSearchList: [
        {
          type: "input",
          label: "姓名：",
          value: "name",
          placeholder: "请输入"
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "职务",
          prop: "duty",
        },
        {
          label: "姓名",
          prop: "name",
        },
        {
          label: "职称",
          prop: "positionalTitles",
        },
        {
          label: "证书名称",
          prop: "certificateName",
        },
        {
          label: "级别",
          prop: "level",
        },
        {
          label: "证号",
          prop: "number",
        },
        {
          label: "专业",
          prop: "professional",
        },
        {
          label: "操作",
          slotName: "op",
        },
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0,
      // 勾选的数组
      multipleSelection: [],
    }
  },
  // 注册组件
  components: {
    OrganizationAllocationDetails, // 详情
  },
  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {
    /**
     * 打开时调用
     */
    fun_Open(){
      // 注册用户并且操作类型不是详情并且不是解除合同
      if (sessionStorage.getItem("userFlag") === "注册用户" && this.controllerFlg != "detail" && this.controllerFlg != "jcht") {
        // 表头按钮组
        this.btnList = [
          {
            name: "添加",
            type: "success",
            icon: "document-add"
          },
          {
            name: "修改",
            type: "primary",
            icon: "edit"
          },
          {
            name: "删除",
            type: "danger",
            icon: "delete"
          }
        ];
      }
      // 调用一览查询
      this.fun_GetList();
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/organizationAllocation/list", {
        ...this.form,
        ...this.reqPageData,
        contractRecordDirectlyId: this.contractRecordDirectlyId,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      })
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
    * 改变每页条数执行的函数
    * @params e 每页条数
    * @author 滕威
    */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 跳转新增页面
          this.fun_Add();
          break;
        case "修改":
          // 调用修改方法
          this.fun_Edit();
          break;
        default:
          // 调用删除方法
          this.fun_Del();
      }
    },
    /**
     * 查看详情
     * @author shuhua
     */
    fun_LookDetails(e) {
      // 打开弹窗
      this.$refs.organizationAllocationDetails.dialogVisible = true;
      // 设置主键
      this.$refs.organizationAllocationDetails.id = e.id;
      // 设置直接发包主键
      this.$refs.organizationAllocationDetails.contractRecordDirectlyId = this.contractRecordDirectlyId;
      // 设置操作标志
      this.$refs.organizationAllocationDetails.controllerFlg = "detail";
      // 请求接口
      this.$refs.organizationAllocationDetails.fun_Open();
    },
    /**
     * 新增
     */
    fun_Add(){
      // 打开弹窗
      this.$refs.organizationAllocationDetails.dialogVisible = true;
      // 设置主键
      this.$refs.organizationAllocationDetails.id = null;
      // 设置直接发包主键
      this.$refs.organizationAllocationDetails.contractRecordDirectlyId = this.contractRecordDirectlyId;
      // 设置操作标志
      this.$refs.organizationAllocationDetails.controllerFlg = "insert";
      // 请求接口
      this.$refs.organizationAllocationDetails.fun_Open();
    },
    /**
     * 修改
     */
    fun_Edit(){
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 打开弹窗
          this.$refs.organizationAllocationDetails.dialogVisible = true;
          // 设置主键
          this.$refs.organizationAllocationDetails.id = this.multipleSelection[0].id;
          // 设置直接发包主键
          this.$refs.organizationAllocationDetails.contractRecordDirectlyId = this.contractRecordDirectlyId;
          // 设置操作标志
          this.$refs.organizationAllocationDetails.controllerFlg = "update";
          // 请求接口
          this.$refs.organizationAllocationDetails.fun_Open();
        }
      } else {
        // 未勾选，则提示
        this.$alert("请至少选中一行数据！", "warning");
        return;
      }
    },
    /**
     * 删除
     */
    fun_Del(){
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过一条
        if (this.multipleSelection.length > 1) {
          // 勾选多条时，提示
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        } else {
          // 弹出询问confirm
          this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 获取id
            const id = fun_GetKeys(this.multipleSelection);
            // 发起请求，获取结果集
            fun_PostAction("/organizationAllocation/delete?keys=" + id + "&contractRecordDirectlyId=" + this.contractRecordDirectlyId).then(res => {
              // 解构res.data
              const { result, msg } = res.data;
              // 判断请求是否成功
              if (result) {
                // 查询列表
                this.fun_GetList();
                // 提示删除成功
                this.$message.success(msg);
              } else {
                // 请求失败，提示信息
                this.$message.error(msg);
              }
            });
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
  }
}